import { IndianRupee } from 'lucide-react';
import type { ProviderPricing } from '../types';

interface PriceComparisonTableProps {
  pricing: ProviderPricing[];
}

export default function PriceComparisonTable({ pricing }: PriceComparisonTableProps) {
  if (pricing.length === 0) return null;

  return (
    <div className="card p-4">
      <h3 className="text-sm font-bold text-gray-900 mb-3 flex items-center gap-2">
        <IndianRupee className="w-4 h-4 text-teal-600" />
        Pricing
      </h3>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-gray-100">
              <th className="text-left py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">Service</th>
              <th className="text-right py-2 text-xs font-semibold text-gray-500 uppercase tracking-wider">Price</th>
              <th className="text-left py-2 pl-3 text-xs font-semibold text-gray-500 uppercase tracking-wider">Unit</th>
              <th className="text-left py-2 pl-3 text-xs font-semibold text-gray-500 uppercase tracking-wider hidden sm:table-cell">Note</th>
            </tr>
          </thead>
          <tbody>
            {pricing.map((item, i) => (
              <tr key={i} className={i % 2 === 0 ? 'bg-gray-50/50' : ''}>
                <td className="py-2.5 text-gray-900 font-medium">{item.service}</td>
                <td className="py-2.5 text-right font-semibold text-gray-900 whitespace-nowrap">
                  <span className="text-xs text-gray-400 mr-0.5">&#8377;</span>
                  {item.price.toLocaleString('en-IN')}
                </td>
                <td className="py-2.5 pl-3 text-gray-500 text-xs">{item.unit}</td>
                <td className="py-2.5 pl-3 text-gray-400 text-xs hidden sm:table-cell">{item.note || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
